import { render, staticRenderFns } from "./addClass.vue?vue&type=template&id=59640d3b"
import script from "./addClass.vue?vue&type=script&lang=js"
export * from "./addClass.vue?vue&type=script&lang=js"
import style0 from "./addClass.vue?vue&type=style&index=0&id=59640d3b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports